import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import BookingApprove from "../BookingApprove";

const BookingRejected = () => {
  return (
    <MasterLayout>
      {/* Breadcrumb */}
      <Breadcrumb title="Booking List" />
      {/* <BookingReject /> */}
      <BookingApprove status={3}/>
    </MasterLayout>
  );
};

export default BookingRejected;
